<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: "App"
	};
</script>

<style>
	html,
	body {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 0px;
		margin: 0px;
    overflow: hidden;
	}

	#app {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		widows: 100%;
		height: 100%;
	}

	.el-breadcrumb {
		line-height: 40px;

	}

	input::-webkit-input-placeholder {
		color: #7c7c7c !important;
	}

	input::-moz-input-placeholder {
		color: #7c7c7c !important;
		opacity: 1 !important;
	}
	input:-moz-input-placeholder {
		color: #7c7c7c !important;
		opacity: 1 !important;
	}
	input::-ms-input-placeholder {
		color: #7c7c7c !important;
	}
	input:-moz-placeholder,
input::-moz-placeholder {
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue